import React, { useEffect, useState } from 'react';
import { Settings as SettingsIcon, Key, Lock, Save, ExternalLink, Globe } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function Settings() {
  const [settings, setSettings] = useState({ apify_token: '', company_name: '', default_country_code: '54' });
  const [passwords, setPasswords] = useState({ current_password: '', new_password: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/settings').then(res => setSettings(prev => ({ ...prev, ...res.data })));
  }, []);

  const saveSettings = async () => {
    setSaving(true);
    try {
      await api.put('/settings', settings);
      toast.success('Configuración guardada');
    } catch (err) { toast.error('Error al guardar'); }
    finally { setSaving(false); }
  };

  const changePassword = async () => {
    if (passwords.new_password !== passwords.confirm) return toast.error('Las contraseñas no coinciden');
    if (passwords.new_password.length < 6) return toast.error('Mínimo 6 caracteres');
    try {
      await api.put('/auth/change-password', {
        current_password: passwords.current_password,
        new_password: passwords.new_password
      });
      toast.success('Contraseña actualizada');
      setPasswords({ current_password: '', new_password: '', confirm: '' });
    } catch (err) { toast.error(err.response?.data?.error || 'Error al cambiar contraseña'); }
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <SettingsIcon size={24} color="var(--accent)" />
        <h1 style={{ fontSize: 26, fontWeight: 800 }}>Configuración</h1>
      </div>

      {/* Apify Config */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <Key size={18} color="var(--accent)" />
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>Conexión con Apify</h3>
        </div>
        <div className="form-group">
          <label>API Token de Apify</label>
          <input type="password" value={settings.apify_token || ''} 
            onChange={e => setSettings({...settings, apify_token: e.target.value})}
            placeholder="apify_api_XXXXXXXXXXXXXXX" />
          <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
            Lo encontrás en Apify → Settings → Integrations → Personal API tokens
          </p>
        </div>
        <a href="https://console.apify.com/account/integrations" target="_blank" rel="noopener noreferrer"
          style={{ fontSize: 13, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          <ExternalLink size={12} /> Ir a Apify para obtener el token
        </a>
      </div>

      {/* General */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <Globe size={18} color="var(--accent)" />
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>General</h3>
        </div>
        <div className="form-group">
          <label>Nombre de la empresa</label>
          <input value={settings.company_name || ''} onChange={e => setSettings({...settings, company_name: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Código de país por defecto (para WhatsApp)</label>
          <input value={settings.default_country_code || ''} onChange={e => setSettings({...settings, default_country_code: e.target.value})}
            placeholder="54" style={{ width: 100 }} />
          <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>Argentina = 54, México = 52, Colombia = 57, etc.</p>
        </div>
      </div>

      <button className="btn btn-primary" onClick={saveSettings} disabled={saving} style={{ marginBottom: 28 }}>
        <Save size={16} /> {saving ? 'Guardando...' : 'Guardar configuración'}
      </button>

      {/* Password */}
      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <Lock size={18} color="var(--accent)" />
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>Cambiar contraseña</h3>
        </div>
        <div className="form-group">
          <label>Contraseña actual</label>
          <input type="password" value={passwords.current_password}
            onChange={e => setPasswords({...passwords, current_password: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Nueva contraseña</label>
          <input type="password" value={passwords.new_password}
            onChange={e => setPasswords({...passwords, new_password: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Confirmar nueva contraseña</label>
          <input type="password" value={passwords.confirm}
            onChange={e => setPasswords({...passwords, confirm: e.target.value})} />
        </div>
        <button className="btn btn-secondary" onClick={changePassword}>
          <Lock size={14} /> Cambiar contraseña
        </button>
      </div>
    </div>
  );
}
